import React from 'react'
import styles from './index.module.css'

const spinner = () => (
  <div className={styles.Spinner}></div>
)

export default spinner